import { API_BASE_URL } from '../../config'
import { getToken } from '../authentication/apiAuthentication'
import axios from "axios";

class SoftwareManagementService {

    static formatResponse(originalData = null,status = -1) {
        if(originalData === null || originalData === undefined || originalData === "")
        {
            switch(status) {                
                case 0 :
                    return {error: "Disconnected from server!",authorized:true};
                case 401:
                case 403:
                    return {error:null,authorized:false};
                case 413:
                    return {error:"Server Rejected File: File was too large!",authorized:false};
                case 204:
                    return {error:null,authorized:true};
                default:
                    return {error:"Unknown Error",authorized:true};
            }
        }else{                        
            originalData.authorized = status !== 401 && status !== 403;

            if (status !== 200 || status !== 201)
            {
                originalData.error = originalData.message;
                originalData.message = null;
            }

            return originalData;
        }
    }

    static async canAccessSoftwareBackend() {
        try {
            let token = await getToken("none");
            const response = await axios.get(`${API_BASE_URL}/v1/software/ping`,{headers: { "Authorization" : `Bearer ${token}`}});
            if(response.status !== 200)
            {
                return false;
            }          

            return true;
        }
        catch(e) {
            return false;        
        }
    }

    static async postSoftwarePackagesToServer(files) {                      
        const formData = new FormData();    
        formData.append("fileCount",files.length);

        for(var i = 0; i < files.length; i++)
        {
            formData.append("file"+i,files[i]);
        }        
        
        try {
            let token = await getToken("none");
            const response = await axios.post(`${API_BASE_URL}/v1/software/workspace`, formData, {headers: { "Content-Type": "multipart/form-data", "Authorization":`Bearer ${token}`}});
    
            if(response.status !== 200)
            {
                console.error(`Error posting files! ${response.statusText}(${response.status})`);
            }          

            return SoftwareManagementService.formatResponse(response.data,response.status);
        }
        catch(e) {
            if (e.response)
            {
                console.error(`Error posting files! ${e.response.data ? e.response.data.message : "[Null Response]"}(${e.response.status})`);
                return SoftwareManagementService.formatResponse(e.response.data,e.response.status);
            }
            else
            {
                console.error("Error posting files!");
                console.error(e);
                return SoftwareManagementService.formatResponse();
            }            
        }
      }

    static async getSerialNumbers() {
        try {
            let token = await getToken("none");
            const response = await axios.get(`${API_BASE_URL}/v1/software/serialnumbers`,{headers: { "Authorization":`Bearer ${token}`}});

            if(response.status !== 200){
                console.error(`Error getting serial numbers! ${response.statusText}(${response.status})`)                
            }          

            return SoftwareManagementService.formatResponse(response.data,response.status);
        }
        catch(e) {
            if (e.response)
            {
                console.error(`Error getting serial numbers! ${e.response.data ? e.response.data.message : "[Null Response]"}(${e.response.status})`);
                return SoftwareManagementService.formatResponse(e.response.data,e.response.status);
            }
            else
            {
                console.error("Error getting serial numbers!");
                console.error(e);
                return SoftwareManagementService.formatResponse();
            }     
        }
    }
    
    static async getSoftwareFileTree() {
        try {
            let token = await getToken("none");
            const response = await axios.get(`${API_BASE_URL}/v1/software/tree`,{headers: { "Content-Type": "multipart/form-data", "Authorization":`Bearer ${token}`}});
    
            if(response.status !== 200)
            {
                console.error(`Error getting tree! ${response.data.message}(${response.status})`);                    
            }          

            return SoftwareManagementService.formatResponse(response.data,response.status);
        }
        catch(e) {
            if (e.response)
            {
                console.error(`Error getting tree data! ${e.response.data ? e.response.data.message : "[Null Response]"}(${e.response.status})`);
                return SoftwareManagementService.formatResponse(e.response.data,e.response.status);
            }
            else
            {
                console.error("Error getting tree data!");
                console.error(e);
                return SoftwareManagementService.formatResponse();
            }   
        }
    }
    
    static async moveFileToTarget(fileId,target) {
        try {
            let token = await getToken("none");
            const response = await axios.post(`${API_BASE_URL}/v1/software/tree`, {id:fileId,target:target}, {headers: { "Authorization":`Bearer ${token}`}});
    
            if(response.status !== 204)
            {
                console.error(`Error moving files! ${response.statusText}(${response.status})`);                    
            }          

            return SoftwareManagementService.formatResponse(null,response.status);
        }
        catch(e) {
            if (e.response)
            {
                console.error(`Error moving tree folder! ${e.response.data ? e.response.data.message : "[Null Response]"}(${e.response.status})`);
                return SoftwareManagementService.formatResponse(e.response.data,e.response.status);
            }
            else
            {
                console.error("Error moving tree folder!");
                console.error(e);
                return SoftwareManagementService.formatResponse();
            }   
        }
    }
    
    static async deleteFile(fileId) {
        try {
            let token = await getToken("none"); 
            const response = await axios.delete(`${API_BASE_URL}/v1/software/tree`, {headers: { "Authorization":`Bearer ${token}`}, data: {id:fileId}});
    
            if(response.status !== 204)
            {
                console.error(`Error deleting files! ${response.statusText}(${response.status})`);                   
            }          

            return SoftwareManagementService.formatResponse(null,response.status);
        }
        catch(e) {
            if (e.response)
            {
                console.error(`Error deleting tree folder! ${e.response.data ? e.response.data.message : "[Null Response]"}(${e.response.status})`);
                return SoftwareManagementService.formatResponse(e.response.data,e.response.status);
            }
            else
            {
                console.error("Error deleting tree folder!");
                console.error(e);
                return SoftwareManagementService.formatResponse();
            }  
        }    
    }

    static async publishWorkspace(workspace){
        try {
            let token = await getToken("none");
            const response = await axios.post(`${API_BASE_URL}/v1/software/workspace/publish`, workspace, {headers: { "Authorization":`Bearer ${token}`}});
    
            if(response.status !== 204)
            {
                console.error(`Error publishing files! ${response.statusText}(${response.status})`);                    
            }          

            return SoftwareManagementService.formatResponse(null,response.status);
        }
        catch(e) {
            if (e.response)
            {
                console.error(`Error publishing workspace! ${e.response.data ? e.response.data.message : "[Null Response]"}(${e.response.status})`);
                return SoftwareManagementService.formatResponse(e.response.data,e.response.status);
            }
            else
            {
                console.error("Error publishing workspace!");
                console.error(e);
                return SoftwareManagementService.formatResponse();
            }  
        }
    }

    static async deleteWorkspace(workspaceId) {
        try {
            let token = await getToken("none");
            const response = await axios.delete(`${API_BASE_URL}/v1/software/workspace`, {headers: { "Authorization":`Bearer ${token}`}, data: {workspaceId:workspaceId}});
    
            if(response.status !== 204)
            {
                console.error(`Error deleting workspace! ${response.statusText}(${response.status})`);                    
            }          

            return SoftwareManagementService.formatResponse(null,response.status);
        }
        catch(e) {
            if (e.response)
            {
                console.error(`Error deleting workspace! ${e.response.data ? e.response.data.message : "[Null Response]"}(${e.response.status})`);
                return SoftwareManagementService.formatResponse(e.response.data,e.response.status);
            }
            else
            {
                console.error("Error deleting workspace!");
                console.error(e);
                return SoftwareManagementService.formatResponse();
            }  
        }
    
    }
}

export default SoftwareManagementService;

